import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import TsaBackendTable from "../../components/TsaBackendTable/index";
import CreateTsaModal from "../../components/TsaModal/CreateTsaModal";
import { GlobalModal } from "../../helper/GlobalModal";
import useLocalStorage from "../../hooks/useLocalStorage";
import { tracker } from "../../service/mixpanel";

const TsaBackend = () => {
  const [isNewUploaded, setIsNewUploaded] = useState(false);
  const [token, _] = useLocalStorage("token");
  const [searchTerm, setSearchTerm] = useState("");
  const [totalTsaTypes, setTotalTsaTypes] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    tracker.tsaManagement.pageView();
  },[])

  const toggleCreateModal = () => {
    setIsCreateModalOpen((prev) => !prev);
  };

  const handleCreateTsaType = () => {
    // This will open create TSA type modal/form
    toggleCreateModal();
    tracker.tsaManagement.addTsaClick();
  };

  const handleRefresh = () => {
    setIsNewUploaded(!isNewUploaded);
  };

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4 mx-3">
        <div className="d-block mb-4 mb-xl-0">
          <h4>TSA Management</h4>
        </div>

        <div className="asset-toolbar">
          <input
            type="string"
            placeholder="Search TSA Type..."
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button onClick={handleCreateTsaType} variant="primary">
            Create TSA Type
          </Button>
        </div>
      </div>

      <div className="asset-summary-container">
        <div className="asset-summary-box">
          {isLoading ? "Loading..." : `Total TSA Types: ${totalTsaTypes}`}
        </div>
      </div>

      <TsaBackendTable
        isNewUploaded={isNewUploaded}
        searchTerm={searchTerm}
        setTotalTsaTypes={setTotalTsaTypes}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        onRefresh={handleRefresh}
      />

      {/* Create TSA Type Modal */}
      <GlobalModal
        isOpen={isCreateModalOpen}
        title="Create TSA Type"
        onClose={toggleCreateModal}
        size="xl"
      >
        <CreateTsaModal onClose={toggleCreateModal} onRefresh={handleRefresh} />
      </GlobalModal>
    </>
  );
};

export default TsaBackend;
